import {Configuration, Merchant, Notice, Product} from "@/lib/keys";
import {useI18n} from "vue-i18n";
import {LIMITATIONS} from "@/keys";

export const usePriceData = () => {
  const i18n = useI18n();
  const getNoticesForPrice = (position: number, config: Configuration): Notice[] => {
    const notices: Notice[] = [];

    if (position === 1) {
      notices.push({
        type: 'primary',
        message: i18n.t('notices.cheapest'),
      });
    }

    if (notices.length <= 1 && config.price < 50.0) {
      notices.push({
        type: 'grey-darken-1',
        message: i18n.t('notices.less_than_50'),
      })
    }

    if (position >= 1 && position <= 3) {
      notices.push({
        location: 'prepend-title',
        type: 'primary',
        density: 'default',
        size: 'large',
        surface: 'none',
        message: i18n.t(`notices.position_${position}`)
      })
    }

    return notices;
  }

  const buildSortedPrices = (p: Product): Configuration[] => {
    if (!p.merchants) {
      return [];
    }

    const mappedMerchants = Object.fromEntries<Merchant>(
      p.merchants.map((m: Merchant) => [m.id, m])
    );

    return p.prices
      .filter((config: Configuration) => config.price > 10 && config.price < LIMITATIONS.MAX_PRICE && !Number.isNaN(config.price))
      .sort((a: Configuration, b: Configuration) => a.price < b.price ? -1 : 1)
      .map((config: Configuration, index: number) => ({
        ...config,
        merchant: mappedMerchants[config.merchant_id],
        price: config.price ?? -1,
        inStock: config.in_stock,
        notices: getNoticesForPrice(index + 1, config)
      }));
  }

  return {
    getNoticesForPrice,
    buildSortedPrices,
  }
}
